const apiURLBuilder = require('core/apiURLBuilder');
const { COUNTRIES_FLAGS } = require('constants/countries')
const { ENGLISH_LANGUAGE } = require('constants/index');
const { getLanguage } = require('core/i18n').i18n;

const getFlagUrl = (countryCode, pixelsSize) => {
    const language = getLanguage();
    const publicUrl = apiURLBuilder.getPublicSiteUrl()

    if (language === ENGLISH_LANGUAGE) {
        const esUrl = publicUrl.replace(/\/en/, '');
        return `${esUrl}/assets/static/images/banderas/web/${pixelsSize}px/${countryCode}.png`;
    }

    if (COUNTRIES_FLAGS.includes(countryCode)) {
        return `${publicUrl}/assets/static/images/banderas/web/${pixelsSize}px/${countryCode}.png`;
    } else {
        return `${publicUrl}/assets/static/images/banderas/web/20px/GENERIC.png`;
    }
}

module.exports = { getFlagUrl }
